import _toConsumableArray from "D:/xampp/htdocs/SNS_Thai/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
import { topicList, topicCreate } from '@/api/mg';
import $ from 'jquery';
export default {
  data: function data() {
    return {
      isGetResault: false,
      isEmpty: true,
      value: '',
      isInput: false,
      searchTopicList: [],
      hotTopicList: [],
      loading: false,
      finished: false,
      topicParams: {
        'filter[hot]': 1,
        'filter[content]': '',
        perPage: '10',
        page: '0'
      },
      totalPage: ''
    };
  },
  created: function created() {
    // this.topicParams['filter[content]'] = ''
    // this.getTopicList(this.topicParams)
  },
  mounted: function mounted() {
    var u = navigator.userAgent; // 判断手机类型
    if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
      console.log('123452');
      if (window.Android) {
        var devicePixelRatio = window.devicePixelRatio;
        console.log(devicePixelRatio);
        console.log(window.Android.getStatusBarHeight());
        var pxSize = Number(window.Android.getStatusBarHeight() / devicePixelRatio);
        console.log('pxsize', pxSize);
        $('.container').css('padding-top', pxSize);
      }
    }
  },
  methods: {
    onLoad: function onLoad() {
      console.log('onLoad');
      this.topicParams['page']++;
      this.topicParams['filter[content]'] = '';
      this.getTopicList(this.topicParams);
    },
    toTopic: function toTopic(topicId) {
      this.$router.push({
        path: '/social/topic',
        query: {
          topicId: topicId,
          from: 'search'
        }
      });
    },
    createTopic: function createTopic() {
      var _this = this;
      var params = {
        topic_name: this.value
      };
      topicCreate(params).then(function (res) {
        if (res.Code === 0) {
          _this.fiinshed = false;
          _this.loading = false;
          _this.isInput = false;
          _this.topicParams.page = 0;
          _this.topicParams['filter[content]'] = '';
          _this.hotTopicList = [];
          _this.isShowPop = false;
          _this.isEmpty = true;
          _this.value = '';
          // this.getTopicList(this.topicParams)
        } else {
          _this.$toast(res.Message);
        }
      });
    },
    clear: function clear() {
      this.value = '';
      this.isInput = false;
      this.isResults = false;
      this.isEmpty = true;
    },
    getTopicList: function getTopicList(params, type) {
      var _this2 = this;
      topicList(params).then(function (res) {
        if (res.Code === 0) {
          _this2.loading = false;
          if (type === 'search') {
            _this2.searchTopicList = res.Data.pageData;
            _this2.totalPage = res.Data.totalPage;
            if (_this2.searchTopicList.length === 0) {
              _this2.isGetResault = true;
            } else {
              _this2.isGetResault = false;
            }
            return;
          }
          _this2.hotTopicList = [].concat(_toConsumableArray(_this2.hotTopicList), _toConsumableArray(res.Data.pageData));
          _this2.totalPage = res.Data.totalPage;
          if (_this2.topicParams['page'] === _this2.totalPage) {
            _this2.finished = true;
          }
        } else {
          _this2.$toast(res.Message);
        }
      });
    },
    input: function input() {
      this.topicParams['page'] = '1';
      if (this.value.trim()) {
        this.topicParams['perPage'] = '50';
        this.isGetResault = false;
        this.isInput = true;
        this.isEmpty = false;
        this.topicParams['filter[content]'] = this.value;
        this.getTopicList(this.topicParams, 'search');
      } else {
        this.topicParams['perPage'] = '10';
        this.isInput = false;
        this.isEmpty = true;
      }
      console.log(this.isInput, 'this.isInput');
    },
    back: function back() {
      var _this3 = this;
      var timer = setTimeout(function () {
        _this3.$router.back();
        clearTimeout(timer);
      }, 100);
    }
  }
};